import angular from 'angular'
import company from './company' // 企业信息
// import license from './license' // 应用授权
import passwordPolicies from './passwordPolicies' // 密码策略
import taxCertificate from './taxcertificate' // 税务证管理
import org from './org' // 机构管理
import outSystem from './outsystem' // 外部对接系统
import fnPackage from './fnPackage' // 功能包

export default angular.module('system.syssetting', [company, passwordPolicies, taxCertificate, org, outSystem, fnPackage])
    .config(['$stateProvider', function config($stateProvider) {
        $stateProvider.state('system.syssetting', {
            abstract: true,
            url: '/syssetting',
            template: '<div ui-view></div>',
            title: '系统设置',
        })
    }]).name


// WEBPACK FOOTER //
// ./src/app/system/systemsetting/index.js